import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import LessonWorkspace from '../../../pages/LessonWorkspace';
import { getLessonById } from '../../../utils/lessonsService';
import './StudentLessonView.css';

export default function StudentLessonView({ lessonId, studentData }) {
  const [searchParams] = useSearchParams();
  const homeworkId = searchParams.get('homeworkId');
  const fromHomework = searchParams.get('fromHomework') === 'true'; // Flag to allow editing only from homework page
  const [lessonData, setLessonData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  


  useEffect(() => {
    if (lessonId) {
      loadLessonData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonId]);

  // Слушаем изменения в localStorage для обновлений в реальном времени
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'novas_lessons_data' || e.key === 'lessons') {
        console.log('Lesson data updated, reloading...');
        loadLessonData();
      }
    };

    // Слушаем изменения в localStorage
    window.addEventListener('storage', handleStorageChange);
    
    // Слушаем изменения в текущем окне (для тестирования)
    const handleLocalChange = () => {
      console.log('Local lesson data changed, reloading...');
      loadLessonData();
    };

    // Создаем кастомное событие для обновления
    window.addEventListener('lessonDataUpdated', handleLocalChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('lessonDataUpdated', handleLocalChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const loadLessonData = async () => {
    try {
      if (!isLoading) {
        setIsUpdating(true); // Показываем индикатор обновления
      } else {
        setIsLoading(true);
      }
      setError(null);
      
      console.log('=== StudentLessonView loadLessonData DEBUG ===');
      console.log('lessonId:', lessonId);
      
      // Загружаем урок из Supabase
      const lesson = await getLessonById(lessonId);
      console.log('Loaded lesson from Supabase:', lesson);
      
      if (lesson) {
        setLessonData(lesson);
      } else {
        console.log('Lesson not found in Supabase, trying localStorage fallback...');
        
        // Fallback на localStorage
        const allLessons = JSON.parse(localStorage.getItem('novas_lessons_data') || '[]');
        const lessonFromLocalStorage = allLessons.find(l => l.id === lessonId);
        
        if (lessonFromLocalStorage) {
          console.log('Found lesson in localStorage:', lessonFromLocalStorage);
          setLessonData(lessonFromLocalStorage);
        } else {
          console.error('Lesson not found in Supabase or localStorage');
          setError('Урок не найден');
        }
      }
    } catch (err) {
      setError('Ошибка загрузки урока');
      console.error('Error loading lesson:', err);
      
      // Fallback на localStorage при ошибке
      try {
        const allLessons = JSON.parse(localStorage.getItem('novas_lessons_data') || '[]');
        const lessonFromLocalStorage = allLessons.find(l => l.id === lessonId);
        if (lessonFromLocalStorage) {
          setLessonData(lessonFromLocalStorage);
          setError(null);
        }
      } catch (fallbackErr) {
        console.error('Fallback to localStorage also failed:', fallbackErr);
      }
    } finally {
      setIsLoading(false);
      setIsUpdating(false);
    }
  };

  if (isLoading) {
    return (
      <div className="student-lesson-view">
        <div className="lesson-loading">
          <div className="loading-spinner"></div>
          <p>Загрузка урока...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="student-lesson-view">
        <div className="lesson-error">
          <h3>Ошибка</h3>
          <p>{error}</p>
          <button onClick={loadLessonData} className="retry-btn">
            Попробовать снова
          </button>
        </div>
      </div>
    );
  }

  if (!lessonData) {
    return (
      <div className="student-lesson-view">
        <div className="lesson-not-found">
          <h3>Урок не найден</h3>
          <p>Урок с ID {lessonId} не существует</p>
        </div>
      </div>
    );
  }



  return (
    <div className="student-lesson-view">
      {/* Updating indicator */}
      {isUpdating && (
        <div style={{
          position: 'fixed',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          color: '#444',
          padding: '8px 16px',
          borderRadius: 999,
          fontSize: '13px',
          fontWeight: '500',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
          border: '1px solid rgba(0,0,0,0.07)',
        }}>
          <div style={{
            width: '12px',
            height: '12px',
            border: '2px solid transparent',
            borderTop: '2px solid #888',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            flexShrink: 0,
          }}></div>
          Updating...
        </div>
      )}

      {/* Реальный LessonWorkspace в режиме просмотра для уроков, редактирования только если открыто со страницы homework */}
      <LessonWorkspace 
        isStudent={true} 
        lessonMode={(homeworkId && fromHomework) ? "edit" : "view_only"}

      />
    </div>
  );
}
